import { render, staticRenderFns } from "./ToggleAction.vue?vue&type=template&id=6b56fcbc&scoped=true"
import script from "./ToggleAction.vue?vue&type=script&lang=js"
export * from "./ToggleAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56fcbc",
  null
  
)

export default component.exports